export default "__VITE_ASSET__zmFdzkUw__ 224w, __VITE_ASSET__5tpGFda0__ 448w";